import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DocumentoSolicitudCamViewModel, TwDocumentoSolicitudCamBase } from './solicitud-documentacion.types';
import { Observable, of } from 'rxjs';
import { TwDocumentacionCamViewModel } from 'src/app/components/_mantenimiento/campanias/campania/documentacioncam/documentacioncam.types';

@Injectable()
export class DocumentosSolicitudCamService {
    private solicitudCamEndpoint = this.baseUrl + 'api/campanias/documentoSolicitudCam/';
    private fileEndpoint = this.baseUrl + 'api/core/camdoc/';
    private numeroDocsObligatorioSinAdjuntar = new Map();

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getDocumentosSolicitudCam(idSolicitudCam: number): Observable<DocumentoSolicitudCamViewModel[]> {
        return this.http.get<DocumentoSolicitudCamViewModel[]>(this.solicitudCamEndpoint + idSolicitudCam);
    }

    persist(documentosSolicitudCam: TwDocumentoSolicitudCamBase): Observable<any> {
        if (documentosSolicitudCam) {
            return this.http.post<TwDocumentoSolicitudCamBase>(this.solicitudCamEndpoint + 'persistDoc/', documentosSolicitudCam);
        }
        return of(null);
    }

    save(documentosSolicitudCam: TwDocumentoSolicitudCamBase[]): Observable<any> {
        if (documentosSolicitudCam?.length > 0) {
            return this.http.post<TwDocumentoSolicitudCamBase[]>(this.solicitudCamEndpoint, documentosSolicitudCam);
        }
        return of(null);
    }

    deleteDocumentaciones(idsDocsSolicitudCamList: (number | null | undefined)[]): Observable<any> {
        if (idsDocsSolicitudCamList?.length > 0) {
            return this.http.post<TwDocumentoSolicitudCamBase[]>(this.solicitudCamEndpoint + 'deleteDocs/', idsDocsSolicitudCamList);
        }
        return of(null);
    }

    deleteFile(guid: string): Observable<any> {
        return this.http.delete<string>(this.fileEndpoint + guid);
    }

    /**
     * Este método crea un hash-map donde:
     * - contabiliza el número de documentos obligatorios configurados para el periodo.
     * - contabiliza el número de documentos obligatorios adjuntados en la solicitud
     * Resta al número de documentos configurados, el número de adjuntados y lo devuelve.
     * Si es mayor o igual que cero, la solicitud tiene adjuntados todos los doc. obligatorios.
     * Si es menor que cero, faltan doc. obligatorios por adjuntar.
     * @returns number
     */
    getDocumentosObligatoriosSinAdjuntar(Documentacion: TwDocumentacionCamViewModel[], documentosSolicitudCam: DocumentoSolicitudCamViewModel[]): number {
        this.numeroDocsObligatorioSinAdjuntar.clear();

        if (Documentacion?.length > 0) {
            for (let i = 0; i < Documentacion.length; i++) {
                let doc: TwDocumentacionCamViewModel = Documentacion[i];
                if (doc.Obligatoria) {
                    let numDocObligatoriaYTipo = this.numeroDocsObligatorioSinAdjuntar.get(doc.IdTipoDocumentacion);
                    if (!numDocObligatoriaYTipo) {
                        numDocObligatoriaYTipo = 0;
                    }

                    this.numeroDocsObligatorioSinAdjuntar.set(doc.IdTipoDocumentacion, ++numDocObligatoriaYTipo);
                }
            }
        }
        if (documentosSolicitudCam?.length > 0) {
            for (let j = 0; j < documentosSolicitudCam.length; j++) {
                let docSol: DocumentoSolicitudCamViewModel = documentosSolicitudCam[j];
                if (docSol.Obligatoria) {
                    let numDocObligatoriaYTipo = this.numeroDocsObligatorioSinAdjuntar.get(docSol.IdTipoDocumentacion);
                    if (numDocObligatoriaYTipo > 0) {
                        this.numeroDocsObligatorioSinAdjuntar.set(docSol.IdTipoDocumentacion, --numDocObligatoriaYTipo);
                    }
                }
            }
        }

        let acum = 0;
        this.numeroDocsObligatorioSinAdjuntar?.forEach(v => {
            acum += v;
        });
        return acum;
    }
}
